import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import CollectionTableView from '@/views/collection_table';
import PaginationControls from '@/views/pagination_controls';

const apiCh = Radio.channel('api');
const globalCh = Radio.channel('global');

let template = `
<div class="row header">
    <div class="panel">
        <div class="panel-heading paginated">
            <h1 class="title">Invoices</h1>
            <div class="pagination"></div>
        </div>
        <div class="panel-body">
            <div class="invoices"></div>
        </div>
    </div>
</div>`;

let empty_template = `<td class="text-center placeholder" colspan="{{num_cols}}">
                        <h3>This is where you'll find invoices for your account activity.</h3>
                        <p>Payment is scheduled for the first of every month</p>
                    </td>`;

let EmptyView = Marionette.View.extend({
    template: Handlebars.compile(empty_template),
    tagName: 'tr',
    templateContext: function () {
        return {
            num_cols: this.options.num_cols || 1,
            message: this.options.message || 'Nothing'
        };
    }
});

let invoice_item_template = `
    <td class='date-column'>
        <div class='date-column'>{{#date_simple_UTC}}{{created_at}}{{/date_simple_UTC}}</div>{{! Date }}
    </td>
    <td class='id-column'>
        <div class='id'>{{id}}</div>
    </td>
    <td class='credit-debit'>
        <div class="{{#if credit}}credit{{/if}}">{{amount_str}}</div>
    </td>
    <td class='description'>
        <div>{{description}}</div>{{! Description }}
    </td>`;

var InvoiceItem = Marionette.View.extend({
    template: Handlebars.compile(invoice_item_template),
    tagName: 'tr',
    modelEvents: {
        'all': 'render',
    },
    events: {
        'click': 'show_invoice'
    },
    templateContext: function() {
        let amount =  Number(this.model.get('amount'));
        let amount_str;
        if ( amount < 0 ) {
            amount_str = '- $' + Number(-amount).toFixed(2);
        } else {
            amount_str = '$' + Number(amount).toFixed(2);
        }

        return {
            credit: amount > 0,
            amount_str
        };
    },
    show_invoice: function() {
        globalCh.request('show_invoice', this.model.get('id'));
    }
});

var PlanDetailsWidget = Marionette.View.extend(LayoutMixin).extend({
    className: function(){ return "account widget " + this.getWidth(); },
    ui: {
        pagination: '.pagination',
        invoices: '.invoices'
    },
    regions: {
        pagination: '@ui.pagination',
        invoices: '@ui.invoices'
    },
    template: Handlebars.compile(template),
    modelEvents: {
        'change': 'render'
    },
    onRender: function(){
        const account = globalCh.request('primary_account');
        let collection = new Backbone.Collection( {type: 'invoice'} );
        let invoices = apiCh.request('invoice');
        let pagination_controls = new PaginationControls({
            collection: collection
        });

        let transactions_table = new CollectionTableView({
            collection: collection,
            collectionEvents: {
                'add, remove, update': 'render',
            },
            childView: InvoiceItem,
            emptyView: EmptyView,
            class_name: 'collaborator-list',
            default_sort_column: 1,
            columns: [
                {
                    name: 'Date (UTC)',
                    class_name: 'date-column',
                },
                {
                    name: 'ID',
                    class_name: 'invoice-id',
                },
                {
                    name: 'Amount',
                    class_name: 'credit-debit',
                },
                {
                    name: 'Description',
                    class_name: 'description',
                },
            ]
        });

        account.get_invoices()        
        .done((resp) => {
            pagination_controls.update_prev_next_from_response;
            let items = [];
            if ( resp && resp.data ) {
                resp.data.forEach((r)=> {
                    let s = apiCh.request(r.type, r.id);
                    if (!s) {
                        invoices.add(r);
                        s = apiCh.request(r.type, r.id);
                    }
                    items.push(s);
                });
                transactions_table.collection.reset(items);
                transactions_table.render();
            }
        });

        pagination_controls.on({
            'page': function(filter, models) {
                transactions_table.collection.reset(models);
                transactions_table.render();
            }
        });
        this.showChildView('pagination', pagination_controls);
        this.showChildView('invoices', transactions_table);
    }
});

export default PlanDetailsWidget;
